export default "{\n    \"label\": \"Status\",\n    \"options\": {\n        \"true\": \"Is active\"\n    }\n}\n"